var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoInternetImportCsv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 78
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17843"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1548",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(0 6)",
    fill: "#efe1e4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "check",
    transform: "translate(3 .832)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1548",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(0 .168)",
    fill: "#fa0f43",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31707",
    d: "M38.749 49.904A2.748 2.748 0 1136 47.157a2.748 2.748 0 012.749 2.747z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31708",
    d: "M48.378 39.466l2.59-2.594a21.063 21.063 0 00-10.995-5.815z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31709",
    d: "M35.941 27.027a24.752 24.752 0 0117.617 7.257l2.59-2.59a28.422 28.422 0 00-23.645-8.1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31710",
    d: "M23.422 19.685l-2.59 2.59 3.563 3.563a28.3 28.3 0 00-8.535 5.855l2.588 2.59a24.637 24.637 0 018.753-5.639l2.907 2.906a20.954 20.954 0 00-9.068 5.323l2.582 2.591a17.326 17.326 0 019.545-4.848l3.42 3.42a13.791 13.791 0 00-10.372 4.019l2.59 2.59a10.186 10.186 0 0114.392 0l4.344 4.34 2.59-2.59z",
    fill: "#fff"
  })))));
}

export default SvgNoInternetImportCsv;